import React, { useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import MobileHeaderStats from "components/Headers/MobileHeaderStats.js";

import Dashboard from "views/admin/Dashboard.js";
import Examenes from "views/admin/Examenes.js";
import Simulador from "views/admin/Simulador.js";
import Resultados from "views/admin/Resultados.js";
import Preguntas from "views/admin/Preguntas.js";
import Practica from "views/admin/Practica.js";
import SesionPractica from "views/admin/SesionPractica.js";
import PracticaResultados from "views/admin/PracticaResultados.js";
import PracticaPreguntas from "views/admin/PracticaPreguntas.js";
import Flashcards from "views/admin/Flashcards.js";
import SesionFlashcards from "views/admin/SesionFlashcards.js";
import ResultadosFlashcards from "views/admin/ResultadosFlashcards.js";
import Estadisticas from "views/admin/Estadisticas.js";
import Actividad from "views/admin/Actividad.js";
import DesempenoEspecialidad from "views/admin/DesempenoEspecialidad.js";
import MiCuenta from "views/admin/MiCuenta.js";
import PlanEstudio from "views/admin/PlanEstudio.js";
import RetoInvite from "views/admin/RetoInvite.js";
import RetoLeaderboard from "views/admin/RetoLeaderboard.js";
import Retos from "views/admin/Retos.js";

export default function Mobile() {
  const location = useLocation();
  const showHeaderStats = location.pathname === "/mobile/dashboard";

  useEffect(() => {
    window.sessionStorage.setItem("enarm_mobile_mode", "1");

    const existingMeta = document.querySelector('meta[name="viewport"]');
    const viewportMeta = existingMeta || document.createElement("meta");

    viewportMeta.setAttribute("name", "viewport");
    viewportMeta.setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover"
    );

    if (!existingMeta) {
      document.head.appendChild(viewportMeta);
    }

    const disableZoomStyle = document.createElement("style");
    disableZoomStyle.id = "enarm-mobile-no-zoom";
    disableZoomStyle.textContent = `
      html, body {
        touch-action: pan-y;
        overflow-x: hidden;
      }
      body {
        zoom: 1 !important;
        transform: none !important;
      }
    `;

    document.head.appendChild(disableZoomStyle);

    return () => {
      if (existingMeta) {
        existingMeta.setAttribute(
          "content",
          "width=device-width, initial-scale=1, viewport-fit=cover"
        );
      }

      const injectedStyle = document.getElementById("enarm-mobile-no-zoom");
      if (injectedStyle) {
        injectedStyle.remove();
      }
    };
  }, []);

  return (
    <main className={`min-h-screen bg-blueGray-50 ${showHeaderStats ? "mobile-dashboard" : "py-4"}`}>
      {showHeaderStats && <MobileHeaderStats showLogo adminSpacing />}
      <div className={`mx-auto w-full max-w-6xl ${showHeaderStats ? "mobile-dashboard-content px-4" : "px-2 sm:px-4"}`}>
        <Switch>
          <Route path="/mobile/dashboard" exact component={Dashboard} />
          <Route path="/mobile/examenes" exact component={Examenes} />
          <Route path="/mobile/simulador/:examId/resultados" exact component={Resultados} />
          <Route path="/mobile/simulador/:examId/preguntas/:questionId?" exact component={Preguntas} />
          <Route path="/mobile/simulador/:examId" exact component={Simulador} />
          <Route path="/mobile/practica" exact component={Practica} />
          <Route path="/mobile/practica/:sessionId/resultados" exact component={PracticaResultados} />
          <Route path="/mobile/practica/:sessionId/preguntas/:questionId?" exact component={PracticaPreguntas} />
          <Route path="/mobile/practica/:sessionId" exact component={SesionPractica} />
          <Route path="/mobile/flashcards" exact component={Flashcards} />
          <Route path="/mobile/flashcards/:sessionId/resultados" exact component={ResultadosFlashcards} />
          <Route path="/mobile/flashcards/:sessionId" exact component={SesionFlashcards} />
          <Route path="/mobile/estadisticas" exact component={Estadisticas} />
          <Route path="/mobile/actividad" exact component={Actividad} />
          <Route path="/mobile/especialidades" exact component={DesempenoEspecialidad} />
          <Route path="/mobile/mi-cuenta" exact component={MiCuenta} />
          <Route path="/mobile/plan-estudio" exact component={PlanEstudio} />
          <Route path="/mobile/reto/:inviteCode/resultados" exact component={RetoLeaderboard} />
          <Route path="/mobile/reto/:inviteCode" exact component={RetoInvite} />
          <Route path="/mobile/retos" exact component={Retos} />
          <Redirect from="/mobile" to="/mobile/dashboard" />
        </Switch>
      </div>
      <style>
        {`
          .mobile-dashboard-content {
            position: relative;
            z-index: 2;
            margin-top: 0;
            padding-bottom: 1.5rem;
          }
        `}
      </style>
    </main>
  );
}
